import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setShowVerificationPending } from "../../app/slice/authSlice";
import Button from "../Button";
import Modal from "../Modal";
import './verificationPending.scss';

const VerificationPendingModal = ({
  isOpen,
}) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setShowVerificationPending(false));
  }

  const handleDone = () => {
    handleClose();
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      overrideStyle={{
        maxWidth: '400px',
        width: '80%',
        height: 'max-content',
        paddingBottom: '20px',
        paddingTop: '20px',
      }}
      title={"KYC pending"}
      footer={() => (
        <>
          <Button
            label="Cancel"
            onClick={handleClose}
            type="contained"
            btnActionType="button"
          />
          <Button
            label={"Go Live"}
            onClick={handleDone}
            type="flat"
            btnActionType="button"
          />
        </>
      )}
    >
      <div className="add-user-modal !w-full">
        <h3 className="text-center w-full font-regular">
          Your account is not yet live, toggle the go live button to get started
        </h3>
      </div>
    </Modal>
  )
};

export default VerificationPendingModal;
